import React, { Fragment, useEffect } from "react";
import Modal from "../../../components/Modal";
import { InputsSection } from "../../../components/Modal/InputsSection";
import { ModalButtonPrimary } from "../../../components/Modal/ModalButton";
import ModalForm from "../../../components/Modal/ModalForm";
import ModalHeading from "../../../components/Modal/ModalHeading";
import {
  ModalTextBox1,
  ModalDateBox,
} from "../../../components/Modal/ModalTextBox";
import { EditUserSkeleton } from "../../../components/Skeletons/manageUsers";
import { UpdateModMedTextBox } from "../../../components/Modal/UpdateModMedTextBox";

const EditModal = ({ data }) => {
  const {
    modalEditState,
    updateUser,
    setupdateUser,
    onEditClose,
    editEmailHandler,
    updatemanageUser,
  } = data;

  return (
    <Modal show={modalEditState}>
      <ModalHeading heading="Edit User Details" onClose={onEditClose} />
      {updatemanageUser && updatemanageUser.loading ? (
        <EditUserSkeleton />
      ) : (
        <Fragment>
          <ModalForm>
            <InputsSection>
              <ModalTextBox1
                label="First Name"
                placeholder="First Name"
                value={updateUser.fName}
                icon={`/sprite.svg#icon-user`}
                onChange={(event) => {
                  setupdateUser({ ...updateUser, fName: event.target.value });
                }}
                error=""
              />
              <ModalTextBox1
                label="Last Name"
                placeholder="Last Name"
                value={updateUser.lName}
                icon={`/sprite.svg#icon-user`}
                onChange={(event) => {
                  setupdateUser({ ...updateUser, lName: event.target.value });
                }}
                error=""
              />
            </InputsSection>

            <InputsSection>
              <ModalTextBox1
                label="Email"
                placeholder="Email"
                icon={`/sprite.svg#icon-email`}
                value={updateUser.email}
                onChange={() => {}} // No change allowed
                disabled={true} // Make input read-only
                error={
                  updateUser.error && (
                    <p className="error_message">{updateUser.error}</p>
                  )
                }
              />

              <ModalDateBox
                label="Date of Birth"
                value={updateUser.birthDate}
                onChange={(event) => {
                  setupdateUser({
                    ...updateUser,
                    birthDate: event.target.value,
                    birthDateerror: "",
                  });
                }}
                error={updateUser.birthDateerror && updateUser.birthDateerror}
              />
            </InputsSection>

            {updateUser && updateUser.IsModMedEnabled  && ( //|| updateUser.IsAthenaEnabled
              <InputsSection style={{ justifyContent: "inherit" }}>
                {/* <UpdateModMedTextBox
                  label="Enter Patient EHR ID"
                  placeholder="Enter the EHR ID"
                  value={updateUser.MRNId}
                  icon={`/sprite.svg#icon-user`}
                  onChange={(e) => {
                    setupdateUser({
                      ...updateUser,
                      EHRId: e.target.value,
                      EHRIdError: "",
                    });
                  }}
                  error={updateUser.EHRIdError}
                /> */}

                <UpdateModMedTextBox
                  label="Enter Patient MRN ID"
                  placeholder="Enter the MRN ID"
                  value={updateUser.MRNId}
                  icon={`/sprite.svg#icon-user`}
                  onChange={(e) => {
                    setupdateUser({
                      ...updateUser,
                      MRNId: e.target.value,
                      MRNIdError: "",
                    });
                  }}
                  error={updateUser.MRNIdError}
                />
              </InputsSection>
            )}

            <ModalButtonPrimary
              className="modal__actions"
              title="Update"
              onClick={editEmailHandler}
            />
          </ModalForm>
        </Fragment>
      )}
    </Modal>
  );
};

export default EditModal;
